module.exports = __webpack_public_path__ + "media/images/icons/comment-square-4feeb6188d0d9ca779c19f08315e3e2e.svg";